<template>
	<div>
		<el-select v-model="val" v-bind="$attrs" v-on="$listeners">
			<el-option
				v-for="item in data"
				:key="item.value"
				:label="item.label"
				:value="item.value"
			></el-option>
		</el-select>
	</div>
</template>

<script>
import dicts from "@/dict/meterDict";
export default {
	inheritAttrs: false,
	name: "DictSelect",
	props: {
        value: '',
		dict: {
			type: Array,
			default: () => {
				return undefined;
			},
		},
		dictVarName: {
			type: String,
			default: () => {
				return undefined;
			},
		},
	},
	data() {
		return {
			val: this.value,
			data: [],
		};
	},
	mounted() {
		if (this.dict && this.dict instanceof Array) {
			this.data = this.dict;
		} else {
			const data = dicts[this.dictVarName];
			if (data) {
				this.data = data;
			}
		}
	},
};
</script>
